import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import { P2GBox } from '@parcel2go/core-ui';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

const SavedAddresses = lazy(() => import('~/apps/saved-addresses/saved-addresses'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SAVED_ADDRESSES);

  useOnLoad(() => {
    const title = t('SAVED_ADDRESSES_PAGE_TITLE', { defaultValue: 'Saved Addresses' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SAVED_ADDRESSES });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.SavedAddresses }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.SavedAddresses
      }
    });
  });

  return (
    <Tagged tag="screen-saved-addresses">
      <Suspense>
        <P2GBox>
          <SavedAddresses />
        </P2GBox>
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'Saved Addresses';
